import React from 'react'
import { Link, useLocation, useSearchParams } from 'react-router-dom'
import { AuthSplitLayout } from '../components/Auth/AuthShell'
import { REGISTRATION_SUBMITTED_COPY } from '../constants/registrationSubmitted'

export default function RegistrationSubmitted() {
  const location = useLocation()
  const [searchParams] = useSearchParams()
  const email = location.state?.email || searchParams.get('email') || ''

  return (
    <AuthSplitLayout
      title={
        <>
          Welcome to
          <br />
          RotationStreet
        </>
      }
      description="We verify every member so the community can connect on real opportunities with confidence."
      marketingPanel="welcome"
    >
      <div className="auth-success-icon">✉️</div>
      <h1 className="auth-success-title">{REGISTRATION_SUBMITTED_COPY.title}</h1>
      <p className="auth-success-subtitle">{REGISTRATION_SUBMITTED_COPY.body}</p>
      {email ? (
        <p className="auth-success-subtitle" style={{ marginTop: 16 }}>
          {REGISTRATION_SUBMITTED_COPY.emailHint}
          <br />
          <strong>{email}</strong>
        </p>
      ) : null}
      <Link to="/login" className="auth-btn-cta" style={{ display: 'inline-block', textAlign: 'center', textDecoration: 'none' }}>
        {REGISTRATION_SUBMITTED_COPY.cta}
      </Link>
    </AuthSplitLayout>
  )
}
